import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-templates/profile/loading';

export const Route = createFileRoute('/_private/settings/terms-templates/$id')({
  pendingComponent: Loading,
});
